<app-page-body>
  <!-- header -->
  <app-page-header
    *ngIf="!isDialogMode"
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <!-- mobile Auth -->

      <!-- authentication -->
      <section class="tw-mb-2" *ngIf="formPageConfig.isEditMode">
        <fieldset>
          <legend>
            {{ pageVocabs + "legends.authentication" | translate }}
          </legend>

          <div class="row">
            <!-- Not MobileAuthenticated -->
            <div
              class="md:tw-w-full lg:tw-w-1/3"
              *ngIf="model.mobile && !isMobileAuthenticated"
            >
              <div
                matSuffix
                class="tw-w-full tw-px-5 tw-mt-1 tw-flex tw-justify-between tw-items-center flex-wrap bg-light-danger rounded"
              >
                <div class="tw-my-4 dark:tw-text-gray-300">
                  <label class="tw-mx-1 tw-font-medium">
                    {{ "common.mobile" | translate }} :
                  </label>
                  <span class="tw-font-bold tw-text-lg tw-mx-1">
                    {{ model.mobile }}
                  </span>
                  <span class="badge badge-danger tw-mx-1">
                    {{
                      "pages.systemManagement.users.userForm.notConfirmed"
                        | translate
                    }}
                  </span>
                </div>

                <div class="tw-my-4">
                  <a
                    class="tw-font-bold tw-text-lg rounded text-navyBlue tw-cursor-pointer"
                    (click)="openMobileAuthenticationForm()"
                  >
                    <i class="mdi mdi-pencil mdi-18px text-navyBlue"></i>
                    {{ "common.authenticated" | translate }}
                  </a>
                </div>
                <div class="tw-my-4">
                  <a
                    class="tw-font-bold tw-text-lg rounded text-navyBlue tw-cursor-pointer"
                    (click)="openUpdateMobileForm()"
                  >
                    <i class="mdi mdi-pencil mdi-18px text-navyBlue"></i>
                    {{
                      "pages.systemManagement.users.userForm.changeNumber"
                        | translate
                    }}
                  </a>
                </div>
              </div>
            </div>

            <!--  MobileAuthenticated -->
            <div class="md:tw-w-full lg:tw-w-1/3" *ngIf="isMobileAuthenticated">
              <div
                matSuffix
                class="tw-w-full tw-px-5 tw-mt-1 tw-flex tw-justify-between tw-items-center flex-wrap bg-light rounded"
              >
                <div class="tw-my-4 dark:tw-text-gray-300">
                  <label class="tw-mx-1 tw-font-medium">
                    {{ "common.mobile" | translate }} :
                  </label>
                  <span class="tw-font-bold tw-text-lg tw-mx-1">
                    {{ model.mobile }}
                  </span>
                  <span class="badge badge-success tw-mx-1">
                    {{
                      "pages.systemManagement.users.userForm.confirmed"
                        | translate
                    }}
                  </span>
                </div>

                <div class="tw-my-4">
                  <a
                    class="tw-font-bold tw-text-lg rounded text-navyBlue tw-cursor-pointer"
                    (click)="openMobileAuthenticationForm()"
                  >
                    <i class="mdi mdi-pencil mdi-18px text-navyBlue"></i>
                    {{ "common.authenticatedMobile" | translate }}
                  </a>
                </div>
                <div class="tw-my-4">
                  <a
                    class="tw-font-bold tw-text-lg rounded text-navyBlue tw-cursor-pointer"
                    (click)="openUpdateMobileForm()"
                  >
                    <i class="mdi mdi-pencil mdi-18px text-navyBlue"></i>
                    {{
                      "pages.systemManagement.users.userForm.changeNumber"
                        | translate
                    }}
                  </a>
                </div>
              </div>
            </div>

            <!-- twoFactorEnabled -->
            <div class="md:tw-w-full lg:tw-w-1/3">
              <div class="checkbox-section tw-mt-5 tw-ml-2">
                <mat-slide-toggle
                  formControlName="twoFactorEnabled"
                  [(ngModel)]="twoFactorEnabled"
                  [disabled]="!isMobileAuthenticated"
                >
                  {{ "common.twoFactorEnabled" | translate }}</mat-slide-toggle
                >
              </div>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- personal Information -->
      <section class="tw-mb-2">
        <fieldset>
          <legend>
            {{ pageVocabs + "legends.personalInformation" | translate }}
          </legend>

          <div class="row">
            <!-- isForeigner -->
            <div class="tw-w-full">
              <div class="checkbox-section tw-mt-4 tw-ml-2">
                <mat-slide-toggle
                  formControlName="isForeigner"
                  [(ngModel)]="model.isForeigner"
                  (change)="changePersonalInformationValidators()"
                >
                  {{ "common.isForeigner" | translate }}</mat-slide-toggle
                >
              </div>
            </div>
          </div>

          <div class="row">
            <!-- firstName -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.firstName"
                [control]="form?.get('firstName')"
                label="common.firstName"
                [maxLength]="32"
              >
              </form-field>
            </div>

            <!-- lastName -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.lastName"
                [control]="form?.get('lastName')"
                label="common.lastName"
                [maxLength]="32"
              >
              </form-field>
            </div>

            <!-- fatherName -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.fatherName"
                [control]="form?.get('fatherName')"
                label="common.fatherName"
                [maxLength]="32"
              >
              </form-field>
            </div>

            <!-- birthDate -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <datepicker
                [value]="model.birthDate"
                (value)="model.birthDate = $event"
                [control]="form?.get('birthDate')"
                label="common.birthDate"
                (onErrorDatePicker)="showErrorDialog($event)"
              >
              </datepicker>
            </div>

            <!-- nationalCode -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.nationalCode"
                [control]="form?.get('nationalCode')"
                [label]="
                  !model.isForeigner
                    ? 'common.nationalCode'
                    : (fields + 'foreignerCode' | translate)
                "
                [minLength]="model.isForeigner ? 12 : 10"
                [maxLength]="model.isForeigner ? 12 : 10"
                type="tel"
              >
              </form-field>
            </div>

            <!-- identityNumber -->
            <div
              class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4"
              *ngIf="!model.isForeigner"
            >
              <form-field
                [(value)]="model.identityNumber"
                [control]="form?.get('identityNumber')"
                label="common.identityNumber"
                [minLength]="1"
                [maxLength]="10"
                type="tel"
                readonly="formPageConfig.isEdit"
              >
              </form-field>
            </div>

            <!-- phone -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.phone"
                [control]="form?.get('phone')"
                label="common.phone"
                type="tel"
                [maxLength]="11"
              >
              </form-field>
            </div>

            <!-- faxNumber -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.faxNumber"
                [control]="form?.get('faxNumber')"
                label="common.faxNumber"
                type="tel"
                [maxLength]="11"
              >
              </form-field>
            </div>

            <!-- mobile -->
            <div
              *ngIf="!formPageConfig.isEditMode"
              class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4"
            >
              <form-field
                [(value)]="model.mobile"
                [control]="form?.get('mobile')"
                label="common.mobile"
                type="tel"
                [maxLength]="12"
                [isMobileField]="true"
              >
              </form-field>
            </div>

            <!-- country -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <zones-select-search
                label="common.country"
                class="tw-w-full"
                type="byZoneType"
                [zoneType]="ZoneType.Country"
                [control]="form?.get('country')"
                [value]="selectedCountry"
                (valueChange)="onChangeZones($event, 'states')"
                (onError)="onClose()"
              >
              </zones-select-search>
            </div>

            <!-- state -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <zones-select-search
                label="common.state"
                class="tw-w-full"
                [control]="form?.get('state')"
                [id]="selectedCountry"
                [value]="selectedState"
                (valueChange)="onChangeZones($event, 'cities')"
                (onError)="onClose()"
              >
              </zones-select-search>
            </div>

            <!--city(zoneId) -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <zones-select-search
                label="common.city"
                class="tw-w-full"
                [id]="selectedState"
                [control]="form?.get('zoneId')"
                [value]="selectedState ? model.zoneId : null"
                (valueChange)="selectedState ? (model.zoneId = $event) : ''"
                (onError)="onClose()"
              >
              </zones-select-search>
            </div>

            <!-- zipCode -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.zipCode"
                [control]="form?.get('zipCode')"
                label="common.zipCode"
                type="tel"
                [maxLength]="10"
                [minLength]="10"
              >
              </form-field>
            </div>

            <!-- address -->
            <div class="md:tw-w-1/2">
              <form-textarea
                class="tw-w-full"
                label="common.address"
                [(value)]="model.address"
                [control]="form?.get('address')"
                [rows]="1"
              >
              </form-textarea>
            </div>

            <!-- password & confirm password -->
            <div class="lg:tw-w-2/3 xl:tw-w-1/2">
              <app-set-password
                class="tw-w-full"
                responsiveClass="md:tw-w-1/2"
                [isRequired]="formPageConfig.isEditMode ? false : true"
                [isRefreshForm]="isRefreshForm"
                (isRefreshForm)="isRefreshForm = $event"
                (password)="model.password = $event"
                (form)="passwordForm = $event"
              >
              </app-set-password>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- system Information -->
      <section class="tw-mb-2">
        <fieldset>
          <legend>
            {{ pageVocabs + "legends.systemInformation" | translate }}
          </legend>

          <div class="row">
            <!-- userName -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.userName"
                [control]="form?.get('userName')"
                label="common.userName"
                [maxLength]="32"
              >
              </form-field>
            </div>

            <!-- email -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.email"
                [control]="form?.get('email')"
                label="common.email"
              >
              </form-field>
            </div>

            <ng-container>
              <!-- organizationId -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <organization-select-search
                  *ngIf="isEnableSystemInfo()"
                  class="tw-w-full"
                  [type]="
                    userType == 'reseller'
                      ? 'currentResellerOrganization'
                      : 'organizationForCreateUser'
                  "
                  [control]="form?.get('organizationId')"
                  [(value)]="model.organizationId"
                  (onError)="onClose()"
                >
                </organization-select-search>
                <form-field
                  *ngIf="!isEnableSystemInfo()"
                  [value]="this.formPageConfig.editData.organizationName"
                  (valueChange)="(model.organizationId)"
                  [control]="form?.get('organizationId')"
                  label="common.organization"
                >
                </form-field>
              </div>

              <!-- expireDate -->
              <div class="sm:tw-w-1/2 md:tw-w-2/3 xl:tw-w-1/2">
                <app-date-time-picker
                  [config]="dateTimeConfig"
                  (dateTime)="model.expireDate = $event"
                >
                </app-date-time-picker>
              </div>

              <!-- descriptions -->
              <div class="md:tw-w-2/3 xl:tw-w-3/4">
                <form-textarea
                  class="tw-w-full"
                  label="common.description"
                  [(value)]="model.descriptions"
                  [control]="form?.get('description')"
                  [rows]="4"
                >
                </form-textarea>
              </div>

              <!-- checkBoxes  -->
              <div class="tw-flex tw-flex-wrap">
                <!-- isActiveSend -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isActiveSend"
                    [(ngModel)]="model.isActiveSend"
                  >
                    {{ "common.isActiveSend" | translate }}</mat-slide-toggle
                  >
                </div>

                <!-- isActive -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isDefault"
                    [(ngModel)]="model.isDefault"
                  >
                    {{ "common.isActive" | translate }}</mat-slide-toggle
                  >
                </div>

                <!-- isSendSmsDescriptionRequired -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isSendSmsDescriptionRequired"
                    [(ngModel)]="model.isSendSmsDescriptionRequired"
                  >
                    {{
                      fields + "isSendSmsDescriptionRequired" | translate
                    }}</mat-slide-toggle
                  >
                </div>

                <!-- isCanSeeContactsOfPublicPhonebooks -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isCanSeeContactsOfPublicPhonebooks"
                    [(ngModel)]="model.isCanSeeContactsOfPublicPhonebooks"
                    [disabled]="
                      isAdmin && !permissionService.userState()?.isSuperAdmin
                    "
                  >
                    {{
                      fields + "isCanSeeContactsOfPublicPhonebooks" | translate
                    }}</mat-slide-toggle
                  >
                </div>

                <!-- isCanSeeContactsOfPrivatePhonebooks -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isCanSeeContactsOfPrivatePhonebooks"
                    [(ngModel)]="model.isCanSeeContactsOfPrivatePhonebooks"
                    [disabled]="
                      isAdmin && !permissionService.userState()?.isSuperAdmin
                    "
                  >
                    {{
                      fields + "isCanSeeContactsOfPrivatePhonebooks" | translate
                    }}</mat-slide-toggle
                  >
                </div>

                <!-- isCanSendSmartWithoutConfirmation -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isCanSendSmartWithoutConfirmation"
                    [(ngModel)]="model.isCanSendSmartWithoutConfirmation"
                  >
                    {{
                      fields + "isCanSendSmartWithoutConfirmation" | translate
                    }}</mat-slide-toggle
                  >
                </div>
              </div>
            </ng-container>
          </div>
        </fieldset>
      </section>

      <!-- role Information -->
      <section *ngIf="!input_isCurrentUser">
        <fieldset>
          <legend>
            {{ pageVocabs + "legends.roleInformation" | translate }}
          </legend>

          <div class="row">
            <role-selection-list
              [class.d-none]="!model.organizationId"
              type="organizationRoles"
              [id]="model.organizationId"
              searchLabel="messages.searchInRoles"
              [values]="model.roleIds"
              (values)="model.roleIds = $event"
            >
            </role-selection-list>

            <p
              [class.d-none]="model.organizationId"
              class="tw-text-gray-700 tw-text-lg tw-my-3 alert alert-primary tw-text-center"
            >
              {{ "messages.selectOrganizationForRoles" | translate }}
            </p>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
